import React from 'react'
import { useAuth } from '../AuthContext'

const RevokedTokens = () => {
  const { user, fetchWithAuth } = useAuth()
  const [items, setItems] = React.useState([])
  const [q, setQ] = React.useState('')
  const [limit, setLimit] = React.useState(20)
  const [offset, setOffset] = React.useState(0)
  const [total, setTotal] = React.useState(0)

  const load = React.useCallback(async () => {
    try{
      const params = new URLSearchParams({ q: q || '', limit: String(limit), offset: String(offset) })
      const res = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/api/revoked?${params.toString()}`)
      if (!res.ok) throw new Error('Fetch failed')
      const data = await res.json()
      setItems(data.revoked || [])
      setTotal(data.total || 0)
    }catch(e){
      console.error(e)
      setItems([])
      setTotal(0)
    }
  }, [fetchWithAuth, q, limit, offset])

  React.useEffect(() => { if (user?.token) load() }, [user?.token, load])

  return (
    <div className="min-h-screen bg-soft p-6">
      <div className="container-custom mx-auto">
        <h1 className="text-2xl font-bold mb-4">Revoked Refresh Tokens</h1>

        <div className="mb-4 flex gap-2">
          <input value={q} onChange={e=>setQ(e.target.value)} placeholder="search token or email" className="px-3 py-2 border rounded flex-1" />
          <button onClick={()=>{ setOffset(0); load() }} className="px-3 py-2 border rounded">Search</button>
        </div>

        <div className="mb-4 flex items-center gap-2">
          <label>Page size:</label>
          <select value={limit} onChange={e=>{ setLimit(parseInt(e.target.value)); setOffset(0) }} className="px-2 py-1 border rounded">
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
          <div className="ml-auto">Total: {total}</div>
        </div>

        <div className="bg-white p-4 rounded shadow">
          {items.length === 0 ? <div className="text-gray-600">No revoked tokens found.</div> : (
            <ul className="space-y-2">
              {items.map(i => (
                <li key={i.id} className="p-2 border rounded">
                  <div className="text-sm text-gray-500">{i.revokedAt}</div>
                  <div className="mt-1 text-xs break-all">{i.token}</div>
                  <div className="mt-1 text-sm">{i.email}</div>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="mt-4 flex gap-2">
          <button onClick={()=>{ setOffset(Math.max(0, offset - limit)); load() }} className="px-3 py-1 border rounded">Prev</button>
          <button onClick={()=>{ if (offset + limit < total) { setOffset(offset + limit); load() } }} className="px-3 py-1 border rounded">Next</button>
          <div className="ml-auto">Showing {Math.min(total, offset+1)} - {Math.min(total, offset+limit)} of {total}</div>
        </div>

      </div>
    </div>
  )
}

export default RevokedTokens
